import { render, staticRenderFns } from "./FriendList.vue?vue&type=template&id=af035794&scoped=true&"
import script from "./FriendList.vue?vue&type=script&lang=ts&"
export * from "./FriendList.vue?vue&type=script&lang=ts&"
import style0 from "./FriendList.vue?vue&type=style&index=0&id=af035794&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af035794",
  null
  
)

export default component.exports